export default __webpack_public_path__ + "static/media/plus.5c263443.svg";